import { ElementRef } from '@angular/core';
import { Lookup } from '../lookup/lookup.model';
import { EFormAttachment } from './e-form-attachment.model';

export class EFormControl {
    Id: number;
    ControlType: string;
    DataType = 'string';
    Value: any;
    Label = '';
    IsRequired = false;
    DropdownOptions: Lookup[] = [];
    Width: string;
    Indent: number;
    NoteRows: number;
    ParentObjectId: number;
    Condition: string | boolean;
    ConditionalAction = 'show';
    TextProvidedOnInstance = false;
    Instructions = '';
    InstructionFormat = 'plainText';
    LinkedDBField: number;
    LinkedCSTFieldName: string;
    AttachmentId: number;
    PreviousAttachmentId: number;
    Attachment: EFormAttachment;
    StoreLocation = 'eForm';
    StuPortCategoryId: number;
    FormDocTypeId: number;
    Visible: boolean;
    VerticalAlignment: string;
    RemoveBottomPadding: boolean;
    HasError: boolean;
    CustomField: boolean;
    CustomFieldName: string;
    CustomFieldID: number;
    CustomFieldControlTypeID: number;
    CustomFieldRefName: string;
    CustomFieldBasePage: boolean;
    CustomFieldAllowControlToHandleOwnData: boolean;
    CustomFieldMasterId: number;
    HideLabel: boolean;
    validateFunction: Function;
    DesignPageIndex: number;
    IsCritical: boolean;
    SurveyFieldID: number;
    CannotBeRemoved: boolean;
    HintLabel: string;
    Editable = true;
    Height = '50px';
    PaddingTop: '0px';
    ShowTodayButton = false;
    ShowNowButton = false;
    MaxLength: number;

    getElementRef = (): ElementRef<any> => {
        return null;
    }
}